export enum AccessGroups {
  Vaccines = 'product_covid_vaccines',
  Treatments = 'product_covid_treatments',
  Pandemic = 'product_covid_macro',
  PAD = 'product_pad',
  CardioLipid = 'product_cardio_lipid',
  APIForecast = 'product_covid_api_forecast',
  APIEpidId = 'product_api_infectious_epid',
  APIOutbreak = 'product_api_outbreak',
  APIReport = 'product_api_report',
  APIComprehensiveEpid = 'product_api_comprehensive_epid',
  CovidCommercialVaccines = 'product_covid_supply_and_production',
  Influenza = 'product_influenza',
  InfluenzaCommercial = 'product_influenza_market_and_production',
  InfluenzaEpidemiology = 'product_influenza_disease360',
  RSV = 'product_rsv',
  RSVEpidemiology = 'product_epidemiology_rsv',
  RSVCommercial = 'product_rsv_market_and_production',
  Epidemiology = 'product_covid_epidemiology',
  CovidCommercialTherapeutics = 'product_covid_market_and_production_therapeutics',
  InternalTooling = 'internal_tooling',
  IDA360Vaccines = 'product_ida_vaccines',
  IDA360Treatments = 'product_ida_treatments',
  IDA360ChikV = 'product_ida_chikv',
  IDA360Amr = 'product_ida_amr',
  IDA360Malaria = 'product_ida_malaria',
  IDA360Dengue = 'product_ida_dengue',
  APISiga = 'product_api_siga',
  BetaTester = 'beta_tester',
  Botulism = 'product_outbreak_botulism',
}
